import {Component} from "react";
import "./AdminInfoDati.css";

const AdminInfoDati = class extends Component {
	render() {
		return (
			<div className="AdminInfoDati">
				<p>
					Tutti gli elementi eliminati, moderati o scaduti (utenti e messaggi) vengono eliminati
					“logicamente”, mentre i relativi dati vengono conservati per 6 mesi in caso
					di errori, contestazioni o altre evenienze.
				</p>
				<p>
					Trascorsi 6 mesi i dati vengono “purgati”, cioè eliminati definitivamente.
				</p>
				<p>
					Vengono purgati automaticamente:
				</p>
				<ul>
					<li>Utenti <strong>inattivi</strong> da almeno 180 giorni</li>
					<li>Utenti che si sono <strong>cancellati</strong> da almeno 180 giorni</li>
					<li>Utenti <strong>disabilitati</strong> da almeno 180 giorni</li>
					<li>Messaggi <strong>scaduti</strong> da almeno 180 giorni</li>
					<li>Messaggi <strong>cancellati</strong> da almeno 180 giorni</li>
					<li>Messaggi <strong>moderati</strong> da almeno 180 giorni</li>
				</ul>
				<p>
					Insieme ai dati purgati vengono definitivamente eliminati in cascata
					i relativi dati collegati:
				</p>
				<ul>
					<li>Messaggi di utenti purgati</li>
					<li>Segnalazioni di messaggi purgati</li>
					<li>Segnalazioni da utenti purgati</li>
					<li>Like a messaggi purgati</li>
					<li>Like da utenti purgati</li>
				</ul>
			</div>
		)
	}
}
export default AdminInfoDati;
